export function getIdentPath(legislation: Legislation, isDirectSign = false) {
  const provider = legislation === 'eidas' ? 'srs' : 'intrum'
  const identifier = provider === 'srs' ? 'robo' : 'autoident'

  return `/v1/${isDirectSign ? 'direct/' : ''}user/identification/${provider}/${identifier}`
}
